import { useEffect, useState } from 'react';
import { onResize$ } from 'utils/onResize';

type ImageSizeFormat = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const getSize = (size: number): ImageSizeFormat => {
  if (size < 768) {
    return 'xs';
  }
  if (size < 1024) {
    return 'sm';
  }
  if (size < 1200) {
    return 'md';
  }
  if (size < 1600) {
    return 'lg';
  }
  return 'xl';
};

function useBreakPoint() {
  const [breakPoint, setBreakPoint] = useState(getSize(window.innerWidth));

  useEffect(() => {
    const subscription = onResize$()
      .map(() => getSize(window.innerWidth))
      .distinctUntilChanged()
      .subscribe((newBreakPoint) => setBreakPoint(newBreakPoint));

    return () => subscription.unsubscribe();
  }, []);

  return breakPoint;
}

export default useBreakPoint;
